import React from "react";

import '../../css/sismo_sentido.css';
import gracias from "../../img/gracias.png";
import reporta from "../../img/reporta.png";
import Boton from "../comun/Boton";
import Pagina, { PieDePagina } from "../comun/Pagina";

export default function Gracias(props) {
    return (
        <Pagina
        titulo="¡Muchas gracias por tu colaboración!"
        imgSrc={gracias}
        imgAlt="Muchas gracias por tu colaboración"
        botonesNavegacion={<div/>}

        handleSubmit={()=>{}}
        onSubmit={()=>{}}                
        explicacion={
            <React.Fragment>   
                 Muchas gracias por haber completado el formulario para la evaluación de intensidades del sismo             
            </React.Fragment>
        }
        contenidoPrincipal={
           <div>           
                Te invitamos a conocer los productos que se elaboran con la información que nos proporcionaste en el siguiente botón:                
                <br/><br/>
                <a href="https://www.sgc.gov.co">
                    <img style={{width: "100px"}}src={reporta}/>
                </a>
            </div> }
        ></Pagina>
    )
}

 function Gracias0(props) {
    return (
        <div className="Formulario">
            <div className="ContenidoPrincipal">
                <div className="GraciasTexto">!Muchas gracias por tu colaboración!</div>
                <div className="BarraDibujo">
                    <img style={{width: "322px"}}src={gracias}/>
                </div>              
            </div>

            <div>        
                <Boton texto="Inicio" onClick={props.reiniciarFormulario} />
            </div>
            <PieDePagina/>
        </div>
    )
}